import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';

import { capitalizeFirstLetter } from '../../../../util/text';

import { getLanguagePath } from '../../../Intl/IntlActions';

const Breadcrumbs = ({ location, intl, crumb }) => {
    // console.log(location, location.pathname.split('/'));
    // Enabled on all pages except home & cart
    const pathParts = location.pathname.split('/').filter(part => part);
    const isEnabled = pathParts.length > 1 && !location.pathname.includes('/cart');

    if(!crumb) {
        if(typeof window !== 'undefined' && window.document) {
            const titleParts = `${window.document.title}`.split('-');
            titleParts.pop();
            crumb = titleParts.join('-');
        } else {
            crumb = capitalizeFirstLetter(pathParts.join(' ').replace(/-/g, ' '));
        }
    }

    pathParts.shift();

    if(isEnabled) {
        return (
            <div className="breadcrumbs p-2  text-white">
                <Link to={getLanguagePath('/', intl.locale)} className="text-white"><FormattedMessage id="appHome" defaultMessage="Home" /></Link>
                {' > '}
                <span className="">{crumb}</span>
            </div>
        );
    }
    return null;
};

Breadcrumbs.defaultProps = {
    crumb: '',
};

Breadcrumbs.propTypes = {
    location: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
    crumb: PropTypes.string,
};

export default withRouter(injectIntl(Breadcrumbs));
